<template>
    <div v-if="mode != 'cd'" class="cp-special-badges-and-discount-cnt">
        <div v-if="(hasSpecialBadges && badges.length) || (Object.keys(item?.badge_coupons || {}).length)" class="cp-badges-special-attr">
            <div v-for="(badge, index) in badges" :key="index" :class="['cp-badge-special-attr', badge.fixed && 'fixed']">{{badge.title}}</div>
        
            <template v-if="Object.keys(item?.badge_coupons || {}).length">
                <template v-for="(coupon, id) in item?.badge_coupons" :key="id">
                    <div v-if="!coupon.image && coupon.description && coupon.color_text && coupon.color_bg" class="cp-badge-special-attr" :style="{'background-color': coupon.color_bg, 'color': coupon.color_text}">{{coupon.description}}</div>
                </template>
            </template>		                
        </div>  

        <div v-if="item.discount_percent_custom > 0" class="cp-badge-cnt">
            <span class="cp-badge cp-badge-discount">-{{item.discount_percent_custom}}%</span>
            <span class="cp-save"><BaseCmsLabel code="price_save" /> <span><BaseUtilsFormatCurrency :price="item.basic_price - item.price_custom" /></span></span>
        </div>
    </div>
    <div v-else-if="hasSpecialBadges && badges.length" class="cd-badges-special-attr">
        <div v-for="(badge, index) in badges" :key="index" :class="['cd-badge-special-attr', badge.fixed && 'fixed']">{{badge.title}}</div>
    </div> 
</template>

<script setup>
    const props = defineProps(['item', 'hasSpecialBadges', 'mode']);

    const badges = computed(() => {
        if (!props.item?.attributes_special) return [];

        const totalDynamicAttrs = 15;
        const varAttr = Array.from({ length: totalDynamicAttrs }, (_, i) => `variable_attr${i + 1}`);
        const fixedAttr = Array.from({ length: totalDynamicAttrs }, (_, i) => `fixed_attr${i + 1}`);

        let variableBadges = [];
        let fixedBadges = [];

        props.item.attributes_special.forEach(attr => {
            if (attr.attribute_code === 'posebne_oznake') {
                if (fixedAttr.includes(attr.code) && attr.always_displayed) {
                    fixedBadges.push({ title: attr.title, fixed: true });
                } else if (varAttr.includes(attr.code)) {
                    variableBadges.push({ title: attr.title, fixed: false });
                }
            }
        });

        if (fixedBadges.length >= 1 && variableBadges.length >= 2) {
            return [fixedBadges[fixedBadges.length - 1], variableBadges[variableBadges.length - 1]];
        } 
        else if (fixedBadges.length > 2) {
            return [fixedBadges[fixedBadges.length - 1]];
        } 
        else {
            return [...fixedBadges.slice(-1), ...variableBadges.slice(-1)].slice(0, 2);
        }
    });
</script>